import { hashSeed, pick, seededRandom, daysAgo } from './mock-utils'
import { MOCK_STORE_ROSTER } from './mock-store-roster'

/** Control gap #13 (P2) — theme/marketplace moderation, in case themes are ever shared/sold between merchants. */
export interface MockFlaggedTheme {
  _id: string
  storeId: string
  storeName: string
  themeName: string
  reason: string
  status: 'pending' | 'dismissed' | 'taken_down'
  flaggedAt: string
}

const REASONS = ['Copied from another merchant', 'Trademark violation in assets', 'Broken checkout flow reported']

export function generateFlaggedThemes(count = 8): MockFlaggedTheme[] {
  const rng = seededRandom(hashSeed('admin-theme-moderation'))
  return Array.from({ length: count }, (_, i) => {
    const store = pick(rng, MOCK_STORE_ROSTER)
    return {
      _id: `theme-mod-${i + 1}`,
      storeId: store.id,
      storeName: store.name,
      themeName: `Custom Theme v${randomVersion(rng)}`,
      reason: pick(rng, REASONS),
      status: pick(rng, ['pending', 'pending', 'dismissed'] as const),
      flaggedAt: daysAgo(rng, 60),
    }
  })
}

function randomVersion(rng: () => number): string {
  return `${1 + Math.floor(rng() * 3)}.${Math.floor(rng() * 10)}`
}
